import config from './config';
let sites;
const SITES_STORAGE_KEY = 'sites';
try {
    sites = JSON.parse(sessionStorage.getItem(SITES_STORAGE_KEY));
}
catch (e) { }
export async function getSites() {
    if (!sites) {
        // TODO Should use a generated API client
        const host = window.location.host;
        const brand = host.includes('sezane') ? 'sezane' : 'octobre';
        const cleanedHost = host.replace('www-nocache.', '').replace('www.', '').replace('octobre-editions', 'sezane');
        sites = (await fetch(`https://api.${cleanedHost}/ecommerce-public/v1/sites/${brand}`, {
            headers: {
                'x-api-key': config.apiKey,
            },
        }).then((response) => response.json()));
        sessionStorage.setItem(SITES_STORAGE_KEY, JSON.stringify(sites));
    }
    return sites;
}
